import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  initialize() {
    this.boundConfirmUnload = this.confirmUnload.bind(this);
    this.boundConfirmNavigation = this.confirmNavigation.bind(this);
  }

  connect() {
    this.formSubmitting = false;

    addEventListener("beforeunload", this.boundConfirmUnload);
    addEventListener("turbo:before-visit", this.boundConfirmNavigation);
  }

  disconnect() {
    removeEventListener("beforeunload", this.boundConfirmUnload);
    removeEventListener("turbo:before-visit", this.boundConfirmNavigation);
  }

  handleSubmit(e) {
    this.formSubmitting = true;
  }

  confirmNavigation(e) {
    if (this.warnChanges()) {
      const userWantsToLeave = confirm("Changes that you made may not be saved. Do you want to leave?");
      if (!userWantsToLeave) return e.preventDefault();
    }
  }

  confirmUnload(e) {
    if (this.warnChanges()) {
      e.returnValue = "Changes that you made may not be saved. Do you want to leave?"
    }
  }

  warnChanges() {
    if (this.formSubmitting) return;
    if (!this.unsavedChanges()) return;

    return true;
  }

  unsavedChanges() {
    return this.inputTargets.some(x => x.value.length > 1);
  }
}
